<template>
    <span>

        <span>
          <router-link :to="{name:'PlanningHome'}" tag="a">
                <i class="fas fa-arrow-left"></i>
            </router-link>
            <span >Week Template</span>
            </span>
        </span>
</template>
<script>
    import Vue from 'vue';
    import { mapState, mapActions } from 'vuex'
    import store from '@/store/index.js'

    import Translations from '@/store/translations';


    export default {
        name: "WeekTemplateHeader",
        store,
        components: {
        },
        computed: {
            Translations: () => Translations,

        },
        data() {
            return {}
        }
    }

</script>

<style scoped>
</style>
